import React from 'react';
import { BulmaType, Message } from '@easylife365/react';
import { useTranslation } from 'react-i18next';
import { AdditionalAppsMessageProps } from './types';

/**
 * Tells the user that some of the apps they own through their settings or tasks could not be read, so the
 * list they are looking at may be incomplete. An app that no longer exists is not a failure and never shows this.
 */
const AdditionalAppsMessage: React.FC<AdditionalAppsMessageProps> = ({ failedCount, isRetrying, onRetry }) => {
  const { t } = useTranslation('common', { keyPrefix: 'additionalAppsMessage' });

  if (!failedCount) return null;

  return (
    <Message
      bulmaType={BulmaType.Warning}
      title={t('title')}
      message={t('message')}
      ctaButtons={[
        {
          bulmaType: BulmaType.Primary,
          loading: isRetrying,
          children: t('retry'),
          // A refetch that is already running would be cancelled and restarted by a second click.
          onClick: () => {
            if (!isRetrying) onRetry();
          },
        },
      ]}
    />
  );
};

export default AdditionalAppsMessage;
